'use strict';

window.$ = jQuery;

// RSPCA 
import Header from "../_modules/rspca/header/header";
import Common from "../_modules/rspca/common/common";

// Global
import Accordion from "../_modules/accordion/accordion";
import ParagraphTypeSlick from "../_modules/paragraph--type--slick/paragraph--type--slick";
import ParagraphTypeTimeline from "../_modules/paragraph--type--timeline/paragraph--type--timeline";
import ParagraphTypeWebform from "../_modules/rspca/paragraph--type--webform/paragraph--type--webform";
import Slider from "../_modules/slider/slider";
import Alerts from "../_modules/alerts/alerts";
import Popups from "../_modules/popups/popups";
import Donation from "../_modules/rspca/donation/Donation";
import AnimalOs from "../_modules/rspca/animal-os/AnimalOs";
import matchHeight from "./utils/match-height";
$(() => {
	new Alerts($("#page").data("alert-endpoint"), $(".site-header__alert"), 'dismissedAlerts');
	new Popups($("#page").data("popups-endpoint"), $("body"), 'dismissedPopups');
	new Slider();
	new Accordion();
	new ParagraphTypeSlick();
	new ParagraphTypeTimeline();
	new Header();
	new ParagraphTypeWebform();
	new Common();
	new Donation();
	new AnimalOs();
	matchHeight([
		{
			elements: ".paragraph--type--highlight-item .teaser__image .field--name-field-image img",
			options: {
				byRow: false
			}
		},
	]);
	(() => {
		const blocks = $(".paragraph--type--slider-configurable");
		if (blocks.length < 1) return;
		blocks.each(function (k, v) {
			const block = $(v).find(">.field--name-field-items");
			initServicesSlider(block, {
				responsive: [
					{
						breakpoint: 1024,
						settings: {
							slidesToScroll: 1,
							slidesToShow: 3
						}
					},
					{
						breakpoint: 1680,
						settings: {
							slidesToScroll: 1,
							slidesToShow: 4
						}
					},
				]
			});
		});
	})();

	(() => {
		const blocks_2 = $(".partner-slider");

		if (blocks_2.length < 1) return;



		blocks_2.each(function (k, v) {
			const block = $(v);
			const sliderBlock = block.find(">.view-content");
			if (sliderBlock.length >= 1) {
				initServicesSlider(sliderBlock, { slidesToShow: 5, centerMode: false, autoplay: true, variableWidth: false });
			}
		});
	})();

});


function initServicesSlider(block, options) {
	// console.log(block);
	block.slick({
		dots: false,
		infinite: options?.infinite || true,
		autoplay: options?.autoplay || false,
		autoplaySpeed: 3000,
		slidesToShow: options?.slidesToShow || 5,
		speed: 300,
		slidesToScroll: 1,
		arrows: options?.arrows || true,
		variableWidth: options?.variableWidth || false,
		centerMode: options?.centerMode || false,
		afterChange: function (slick, currentSlide) {
			// Your function to execute on slide change
			console.log("Slide changed to: " + currentSlide);
			// You can add your custom logic or function calls here
		},
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToScroll: 1,
					slidesToShow: 1
				}
			}
		]

	})
}

